import { type RouteObject } from 'react-router-dom';

import Mfa from '@/pages/Mfa';

export const mfa: RouteObject = { path: 'mfa', element: <Mfa /> };
